import * as React from 'react';
import {
  ActivityLogList,
  BottomSheet,
  BottomSheetContent,
  BottomSheetTrigger,
  Button,
  vehicleHistoryActivity,
} from '@relay-towing/ui';
import { Eye } from '@phosphor-icons/react';
import { useVehicleHistory } from '../../hooks/useVehicleHistory';
import { dateAndSeconds } from '../status';

/**
 * "Call activity" under the call's street, opening what has changed on its
 * vehicle and who changed it, as the Figma draws the button (577:140029)
 * and the sheet (577:140196). The same history the dashboard's call panel
 * draws, read the same way; asked for only once the sheet is open.
 */
export function CallActivity({ vehicleId }: { vehicleId: string }) {
  const [open, setOpen] = React.useState(false);
  const { data = [], isLoading } = useVehicleHistory(vehicleId, {
    enabled: open,
  });
  const entries = React.useMemo(
    () => vehicleHistoryActivity(data, dateAndSeconds),
    [data]
  );

  return (
    <BottomSheet open={open} onOpenChange={setOpen}>
      <BottomSheetTrigger asChild>
        <Button variant="secondary" size="lg" pill leadingIcon={<Eye />}>
          Call activity
        </Button>
      </BottomSheetTrigger>
      <BottomSheetContent title="Call activity">
        <ActivityLogList entries={entries} loading={isLoading} />
      </BottomSheetContent>
    </BottomSheet>
  );
}
